module.exports = __webpack_public_path__ + "media/images/list-bullets-a0f7eb64.svg";